var exports = {
  "vN": "ProfilePreview.module__messageIcon___Y2tPRX",
  "pM": "ProfilePreview.module__previewInteractive___Y2tPRX",
  "l5": "ProfilePreview.module__messageButtonWrapper___Y2tPRX",
  "bc": "ProfilePreview.module__profileCustomStatus___Y2tPRX",
  "CQ": "ProfilePreview.module__profileCustomStatusText___Y2tPRX",
};

module.exports = exports;
